// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"209":"69b26a57","623":"0fc390dd"}[chunkId] + ".chunk.css";
};